import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../task-list-dialog.action';
import { defaultState, TaskListDialogState } from '../task-list-dialog.state';

import { Reload } from './reload.action';

export function reloadReducer(
    state: TaskListDialogState,
    action: PayloadAction<ActionType, Reload>,
): TaskListDialogState {
    try {
        return {
            ...defaultState(),
            pending: {
                ...state.pending,
                reload: true,
            },
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
